<template>
  <button
    @click="$emit('click', $event)"
    class="wt-button"
    :class="classObj"
    :disabled="disabled"
    :title="title"
  >
    <wt-google-like-loader v-if="processing" class="-default" />
    <i v-else-if="icon" :class="['wticon', icon]" />

    <span v-if="text" v-text="text" />

    <slot name="suffix"></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'primary',
    },

    title: {
      type: String,
      default: '',
    },

    text: {
      type: String,
      default: '',
    },

    circle: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    icon: {
      type: String,
      default: '',
    },

    iconPosition: {
      type: String,
      default: 'left',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    processing: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    classObj() {
      return [
        {
          [this.type]: true,
          reverse: this.iconPosition === 'right',
          glyph: this.icon && _.isEmpty(this.text),
          circle: this.circle,
          active: this.active,
        },
      ];
    },
  },
};
</script>
